const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      {/* Subtle gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom right, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Subtle ambient shapes */}
        <div
          className="absolute top-0 -left-4 w-72 h-72 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
        <div
          className="absolute -bottom-8 right-0 w-72 h-72 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-5xl text-left md:text-center">
        <h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold tracking-tight mb-3 md:mb-4"
          style={{ color: 'var(--color-heading)' }}
        >
          Gallery
        </h1>

        <p
          className="text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl md:mx-auto"
          style={{ color: 'var(--color-subtle)' }}
        >
          A visual journey through my experiences in competitive chess, robotics engineering,
          varsity badminton, social impact initiatives, and academic achievements across the globe.
        </p>

        <div className="mt-4 md:mt-6 flex items-center md:justify-center gap-4 md:gap-6 flex-wrap">
          <div className="flex items-center gap-2">
            <span className="text-xs sm:text-sm font-medium" style={{ color: 'var(--color-muted)' }}>18 Chess</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs sm:text-sm font-medium" style={{ color: 'var(--color-muted)' }}>33 Robotics</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs sm:text-sm font-medium" style={{ color: 'var(--color-muted)' }}>4 Sports</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
